var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDownFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9593 8.30897C19.9189 8.21754 19.8506 8.13938 19.7629 8.08438C19.6752 8.02938 19.572 8.00002 19.4665 8H4.53425C4.42863 7.99982 4.32534 8.02905 4.23747 8.08397C4.14959 8.13889 4.08109 8.21704 4.04065 8.3085C4.00021 8.39997 3.98964 8.50063 4.0103 8.59772C4.03096 8.69482 4.0819 8.78398 4.15668 8.85391L11.6228 15.8531C11.6723 15.8997 11.7312 15.9366 11.796 15.9618C11.8608 15.987 11.9302 16 12.0004 16C12.0705 16 12.14 15.987 12.2048 15.9618C12.2696 15.9366 12.3284 15.8997 12.3779 15.8531L19.8441 8.85391C19.9186 8.78393 19.9693 8.69481 19.9898 8.59782C20.0103 8.50082 19.9997 8.4003 19.9593 8.30897Z",
    fill: "#141414"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownFilled);
export default __webpack_public_path__ + "static/media/ChevronDownFilled.feddb38bb00902f7b83ad31a3dd9b814.svg";
export { ForwardRef as ReactComponent };